<template>
  <div class="categoryPage page">
    <div class="container">
      <search-template
        v-if="category"
        list-name="Categories list"
        :default-category-id="category.id"
        :search-page="true"
        route-name="category-slug"
        route-pagination-name="category-page-number"
        :show-heading="false"
      />
    </div>
    <LazyHydrate :when-visible="{ rootMargin: '100px' }">
      <newsletter-home white />
    </LazyHydrate>
  </div>
</template>
<script>
import LazyHydrate from 'vue-lazy-hydration';
import { mapState } from 'vuex';
// import MobileBreadcrumbs from '~/components/MobileBreadcrumbs';
import SearchTemplate from '~/components/SearchTemplate';

export default {
  name: 'CategoryPage',
  components: {
    SearchTemplate,
    LazyHydrate,
    NewsletterHome: () => import('~/components/Newsletter/NewsletterHome'),
    // MobileBreadcrumbs,
  },
  async asyncData({ app, $config, error, $axios, route, redirect }) {
    try {
      const {
        data: { category, breadcrumbs, seo },
      } = await $axios.get(`${$config.baseOfixApi}/e-commerce/v1/categories/${route.params.slug}`, {
        useCache: true,
      });

      if (category.slug !== route.params.slug) {
        redirect(
          301,
          app.localePath({
            name: 'category-page-number',
            params: { slug: category.slug, number: route.params.number },
          }),
        );
      }

      return { category, breadcrumbs, seo };
    } catch (e) {
      if (e.response && e.response.data && e.response.status === 308 && e.response.data.message) {
        redirect(
          301,
          app.localePath({ name: 'category-slug', params: { slug: e.response.data.message } }),
        );
      }
      error({ statusCode: 404, message: 'Category not found' });
    }
  },
  nuxtI18n: {
    paths: {
      pl: '/kategoria/:slug/strona/:number',
      en: '/category/:slug/page/:number',
    },
  },
  data() {
    return {
      content: '',
      selectedItem: null,
      breadcrumbs: [],
      category: null,
    };
  },
  head() {
    const currentPage = this.$helper.countCurrentPage(
      this.pagination.limit,
      this.pagination.offset,
    );

    const metaTags = this.seo.metaTags.map(({ content, hid, name }) => ({
      hid,
      name,
      content: content ? `Strona ${currentPage} - ${content}` : '',
    }));

    return {
      title: `Strona ${currentPage} - ${this.seo.title}`,
      meta: this.$helper.metaDescription([
        ...(Object.keys(this.$route.query).length
          ? [
              {
                name: 'robots',
                content: 'noindex, nofollow',
              },
            ]
          : [
              {
                name: 'robots',
                content: 'index, follow',
              },
            ]),
        ...metaTags,
      ]),
      script: [...this.$helper.schemaData(this.seo.schemaOrgData)],
      link: this.$helper.prevNextUrl(
        this.$route.query,
        this.pagination.offset,
        this.pagination.limit,
        this.pagination.countTotal,
        'promotions-slug',
        'promotions-page-number',
      ),
    };
  },
  computed: {
    ...mapState({
      pagination: state => state.productsFilters.search.pagination,
    }),
  },
  methods: {
    setMinHeight(index) {
      if (this.$refs.subcatList[index]) {
        this.selectedItem = this.$refs.subcatList[index];
        const itemHeight = this.selectedItem.clientHeight;
        this.selectedItem.style.minHeight = `${itemHeight}px`;
      }
    },
  },
};
</script>
<style lang="scss">
.categoryPage {
  $root: &;
  // overflow: hidden;

  @include rwd('tablet') {
    overflow-x: hidden;
  }

  &__breadcrumbs {
    @include rwd('tablet') {
      display: none;
    }
  }

  &__mobileBreadcrumb {
    display: none;

    @include rwd('tablet') {
      display: flex;
    }

    @include rwd('small-tablet') {
      padding: 0 2rem;
    }
  }

  &__title {
    @include rwd('small-tablet') {
      padding: 0 2rem;
    }
  }

  &__inner {
    display: flex;
    flex-wrap: wrap;
    margin-top: 3rem;
  }

  &__sidebar {
    padding-right: 3.6rem;
    flex: 0 0 350px;
    max-width: 350px;

    @include rwd('large-laptop') {
      padding-right: 3rem;
      flex: 0 0 280px;
      max-width: 280px;
    }

    @include rwd('large-tablet') {
      display: none;
    }
  }

  &__categories {
    background-color: $cWhite;
  }

  &__categoriesName {
    display: flex;
    align-items: center;
    padding: 2rem;
    font-size: 1.6rem;
    line-height: 2rem;
    font-weight: 600;
    border-bottom: 1px solid $cAddLight;
    width: 100%;
    text-align: left;
  }

  &__categoriesList {
    padding: 2rem;
  }

  &__categoriesListItem {
    // display: flex;
    // align-items: center;
    &:last-child {
      #{$root}__listButton {
        margin-bottom: 0.3rem;
      }
    }
  }

  &__categoriesListLink {
    display: flex;
    margin-bottom: 1rem;
    justify-content: space-between;
    text-align: left;
    font-size: 1.4rem;
    line-height: 2.2rem;
    color: $cMainLight;
    width: 100%;
    transition: color $tr;

    &:hover {
      color: $cSec;
    }
  }

  &__categoriesListAvailable {
    color: $cAddDark02;
    margin-left: 4rem;
  }

  &__content {
    flex: 0 0 calc(100% - 350px);
    max-width: calc(100% - 350px);

    @include rwd('large-laptop') {
      flex: 0 0 calc(100% - 280px);
      max-width: calc(100% - 280px);
    }

    @include rwd('large-tablet') {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }

  &__section {
    background-color: $cWhite;
    padding: 2.5rem 3.5rem 3rem 3.5rem;

    &--smallPadding {
      padding: 2rem 2rem 3rem 2rem;
    }
  }

  &__header {
    text-align: left;
    margin-bottom: 3rem;
  }

  &__headerImage {
    margin-bottom: 2.4rem;
    max-width: 100%;
  }

  &__headerTitle {
    font-size: 3.6rem;
    line-height: 4.5rem;
    font-weight: 600;
    color: $cMainDark;
  }

  &__headerSubtitle {
    font-size: 1.6rem;
    line-height: 2rem;
  }

  &__tiles {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    border-style: solid;
    border-color: $cAddLight;
  }

  &__tile {
    cursor: pointer;
    margin: 0 -1px -1px 0;
    border: 1px solid #e1e1e1;
    flex: 0 0 33.33%;
    width: 33%;
    min-height: 26.3rem;
    position: relative;
    overflow: hidden;
    padding: 2rem;
    transition: opacity $tr;

    @include rwd('large-tablet', true) {
      &:hover {
        overflow: visible;

        #{$root}__tileImageWrapper {
          opacity: 0.7;
        }

        #{$root}__tileSubcats {
          opacity: 1;
          z-index: 1000;
        }

        #{$root}__tileSubcat {
          transform: translateY(0);
        }
      }
    }

    @include rwd('laptop') {
      flex: 0 0 50%;
      width: 50%;
    }

    @include rwd('tablet') {
      min-height: 16rem;
    }

    @include rwd('small-tablet') {
      flex: 0 0 100%;
      width: 100%;
      padding: 1rem 0 1rem 2rem;
    }
  }

  &__tileWrapperLink {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 20;
  }

  &__tileImageWrapper {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    min-height: 11rem;
    margin-bottom: 1.5rem;
    width: 100%;
    transition: opacity $tr;

    @include rwd('small-tablet') {
      margin-right: 1rem;
      margin-bottom: 0;
      width: 11rem;
    }

    @include rwd('small-tablet') {
      align-items: center;
      width: 7rem;
    }
  }

  &__tileImage {
    max-height: 11rem;
    max-width: 100%;

    @include rwd('large-phone') {
      max-height: 8rem;
      max-width: 7rem;
    }
  }

  &__tileText {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    width: 100%;

    @include rwd('small-tablet') {
      padding-right: 3rem;
      flex: 1;
    }
  }

  &__tileIcon {
    display: none;
    font-size: 1.2rem;
    line-height: 1.5rem;
    color: $cMainDark;
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);

    @include rwd('small-tablet') {
      display: block;
      right: 1.5rem;
    }
  }

  &__tileTitle {
    text-align: center;
    max-width: 85%;
  }

  &__tileCatLink {
    color: $cMainDark;
    font-size: 2rem;
    line-height: 2.7rem;

    @include rwd('tablet') {
      font-size: 1.8rem;
      line-height: 2.2rem;
    }
  }

  &__tileSubtitle {
    color: $cMainLight;
    font-size: 1.6rem;
    line-height: 2rem;

    @include rwd('tablet') {
      font-size: 1.4rem;
      line-height: 1.8rem;
    }
  }

  &__tileSubcats {
    transform: translateY(100%);
    opacity: 0;
    background: $cWhite;
    border: 0.5px solid $cAddLight;
    border-top: 0;
    width: calc(100% + 2px);
    bottom: 0;
    position: absolute;
    padding: 0 2rem 2rem;
    transition: opacity $tr, transform $tr;

    @include rwd('large-laptop') {
      bottom: 4px;
    }
  }

  &__tileSubcat {
    color: $cMainLight;
    text-align: center;
    font-size: 1.6rem;
    line-height: 2rem;
    margin-bottom: 0.5rem;
    transform: translateY(-50%);
    transition: transform $trM;
  }

  &__tileSubcatLink {
    display: block;
    transition: color $tr;
    &:hover {
      color: $cSec;
    }
  }

  &__buttonWrapper {
    text-align: center;
  }

  &__button {
    margin-top: 5rem;
    margin-bottom: 2rem;
  }

  &__topSeo {
    margin-bottom: 3rem;
    background-color: $cWhite;
    padding: 2rem;
  }

  &__bottomSeo {
    margin-top: 3rem;
  }
}
</style>
